export const makeNullOption = (label) => ({ value: 0, label });

export const INITIAL_STATE = {
	selected: null,
	subModalOpen: false,
	visibleDelButton: true,
	isValid: {
		title: true
	},
	values: {
		title: '',
		description: ''
	},
	errors: {
		title: ''
	},
	isFormReadyToSubmit: false
};

export function formReducer(state, action) {
	// eslint-disable-next-line default-case
	switch (action.type) {
	case 'SET_SELECTED':
		return {...state, selected: action.payload};
	case 'SET_SUB_MODAL':
		return {...state, subModalOpen: action.payload};
	case 'SET_VISIBLE_DEL_BUTTON':
		return {...state, visibleDelButton: action.payload};
	case 'SET_VALUE':
		return {...state, values: {...state.values, ...action.payload}};
	case 'CLEAR':
		return {
			...state,
			values: INITIAL_STATE.values,
			isFormReadyToSubmit: false,
			errors: INITIAL_STATE.errors
		};
	case 'RESET_VALIDITY':
		return {...state, isValid: INITIAL_STATE.isValid, errors: INITIAL_STATE.errors};
	case 'SUBMIT': {
		const titleValidity = Boolean(String(state.values.title || '').trim().length);
		return {
			...state,
			isValid: { title: titleValidity },
			errors: { title: titleValidity ? '' : 'Обязательное поле' },
			isFormReadyToSubmit: titleValidity
		};
	}
	case 'SET_SUBMIT_FALSE':
		return {...state, isFormReadyToSubmit: false};
	default:
		return state;
	}
}